import { Box, Button, Paper } from '@mui/material'
import React from 'react'
import { Delete } from '@mui/icons-material';

const Panel = React.forwardRef((props, ref) => {
  const { children, header, bodyPadding, index, dayIndex, dayLength, removeDayWeek, item, handleOpen, ...rest } = props
  return (
    <Paper
      style={{
        overflowY: 'auto',
        '&::WebkitScrollbar': {
          width: '0',
        },
        margin: 3,
      }}
      {...rest}
      ref={ref}
    >
      {header && (
        <Box
          className="panel_header"
          style={{ padding: '15px', borderBottom: '1px solid #0000001f', display: 'flex', alignItems: 'center', justifyContent: 'space-between', minWidth: '15vw'}}
          onClick={() => handleOpen(item)}
        >
          {header}
          {dayLength - 1 === dayIndex && (<Button style={{ padding: '0', minWidth: 'auto' }} onClick={removeDayWeek}>
            <Delete style={{ color: 'teal' }} />
          </Button>)}
        </Box>
      )}
      <Box sx={{ p: bodyPadding && bodyPadding, padding: '8px!important' }}>
        {children}
      </Box>
    </Paper>
  )
})

export default Panel
